import { LogLevel } from '@kpmg-tax/core';

export const environment = {
  serviceNowUrl: "#{serviceNowUrl}#",
  supportEmail: "#{supportEmail}#",
  studyOnboardingHelpEmail: "#{studyOnboardingHelpEmail}#",
  production: true,
  logLevel: LogLevel.Error,
  webApiDefaultRoot: "#{webApiDefaultRoot}#",
  rcnUrl:'#{rcnUrl}#',
  rcnSurveyUrl:'#{rcnSurveyUrl}#',
  rcnInternalSurvey:'#{rcnInternalSurvey}#',
  redirectUri:"#{appUrl}#",
  appUrl: "#{ClientApplicationUrl}#",
  apiRoot: "#{apiRoot}#",
  cdnHostname: "",
  assetRootUrl: "#{assetRootUrl}#",
  rcsWatsonDeepLink: "#{RcsWatsonDeepLink}#",
  rcsContractDeepLink: "#{RcsContractDeepLink}#",
  spreadjsLicenseKey: '#{spreadjsLicenseKey}#',
  envName:'#{envName}#',
  activityMonitor: {
    heartbeatInterval: 5, // Minutes between heartbeat messages
    warningTimeout: 25, // Minutes before warning of pending session timeout
    sessionTimeout: 5, // Minutes until session timeout after warning is displayed
  },
  toastrConfig: {
    defaultPosition: 'toast-top-right',
    successTimeout: 5000,
    warningTimeout: 20000,
    errorTimeout: 10000,
    infoTimeout: 5000,
  },
  azure: {
    isCloud: 'true',
    tenant: "#{Authentication.AzureAd.TenantId}#",
    clientId: "#{Authentication.AzureAd.ClientId}#"
  },
  UserProvision: {
    Authority: "#{UserProvision.Authority}#"
  },
  appInsights: {
    instrumentationKey: "#{ApplicationInsights.InstrumentationKey}#",
    ingestionEndPoint: "#{AppInsightsIngestionEndPoint}#",
    liveEndPoint: "#{AppInsightsLiveEndPoint}#"
  },
  workflowBaseURL: "#{workflowBaseURL}#",
  DGDocsBaseURL: "#{DGDocsBaseURL}#"
};
